import React from 'react'
/** An open WebSocket that can be used to communicate with the server */
export const WebSocketContext = React.createContext<WebSocket | null>(null)
export default WebSocketContext
